// @flow
import * as React from 'react';
import type {MIMETypesContextMIMEType as MIMETypeData} from 'docs/types';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';

type MimeTypesProps = {|
  list: Array<MIMETypeData>,
|};

const MimeType = (item: MIMETypeData) => {
  return (
    <tr>
      <TableCell>{item.fileFormat}</TableCell>
      <TableCell>
        <strong>{item.type}</strong>
      </TableCell>
    </tr>
  );
};

export const MimeTypes = ({list}: MimeTypesProps) => {
  return (
    <div className="MimeTypes">
      <Table type="striped">
        <thead>
          <tr>
            <TableHeaderCell>File format</TableHeaderCell>
            <TableHeaderCell>MIME type</TableHeaderCell>
          </tr>
        </thead>
        <tbody>{list.map((item) => MimeType(item))}</tbody>
      </Table>
    </div>
  );
};
